export default {
  required: '必須項目です',
  email: '有効なメールアドレスを入力してください',
  phone: '有効な電話番号を入力してください',
  minLength: '{min}文字以上で入力してください',
  maxLength: '{max}文字以内で入力してください',
  number: '数字を入力してください',
  integer: '整数を入力してください',
  positive: '正の数を入力してください',
  url: '有効なURLを入力してください',
  passwordMismatch: 'パスワードが一致しません',
  passwordWeak: 'パスワードの強度が不足しています',
};
